import { Box, Grid } from "@mui/material";
import React from "react";
import DrawingSelection from "../Components/DrawingSelection";
import TabControl from "./components/TabControl";
import ConsolidateModal from "./components/ConsolidateModal";
import DrawingBomTable from "./components/DrawingBomTable/DrawingBomTable";
import { DrawingBomContext } from "./DrawingBomContext";
import AddSrvModal from "./components/AddSrvModal";
import { useBOMDashboardContext } from "../BOMDashboard.context";
import LabelledBox from "../../../../../../../components/widgets/LabelledBox";
import ComparingModal from "./components/CompareModal";
import MtrModal from "./components/MtrModal";
import ChangeOrderModalModal from "./components/ChangeOrderModal";

export default function Main() {
  const { selectedDrawings, handleAddingNewDrawing } =
    React.useContext(DrawingBomContext);

  const { setSelectedDrawings } = useBOMDashboardContext();

  return (
    <Box>
      <Grid container sx={{}}>
        <Grid item xs={12} xl={6}>
          <LabelledBox sx={{ ml: 5 }}>
            <DrawingSelection
              selectedDrawings={selectedDrawings}
              handleAddingNewDrawing={handleAddingNewDrawing}
              setSelectedDrawings={setSelectedDrawings}
            />
          </LabelledBox>
        </Grid>

        <Grid
          item
          xs={12}
          xl={6}
          sx={{
            display: "flex",
            flexDirection: { xs: "row", xl: "row-reverse" },
          }}
        >
          <LabelledBox
            flexDirection="row-reverse"
            sx={{
              py: { xs: 1.5 },
              ml: { xs: 5, xl: 0 },
              mr: { xs: 0, xl: 5 },
              // width: 500,
              // justifyContent: "space-between",
              // flexWrap: "wrap",
            }}
          >
            {/* <Box>
              <SelectMaterialType />
            </Box> */}
            <TabControl />

            <ConsolidateModal />
            <ChangeOrderModalModal />
            <AddSrvModal />
            <ComparingModal />
            <MtrModal />
          </LabelledBox>
        </Grid>
      </Grid>

      <Box sx={{ mx: 5 }}>
        <DrawingBomTable />
      </Box>
    </Box>
  );
}
